import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";

const Et3Margin = withLiteObserverAndTheme<{
  children?: React.ReactNode;
  top: number;
  bottom: number;
  left: number;
  right: number;
}>((props) => {
  const { children, top, left, right, bottom, theme } = props;
  const { unitX, unitY, colors } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        marginTop: top > 0 ? top * unitY : 0,
        marginLeft: left > 0 ? left * unitX : 0,
        marginRight: right > 0 ? right * unitX : 0,
        marginBottom: bottom > 0 ? bottom * unitY : 0
      }}
      onClick={() => {}}
    >
      {children}
    </ET3Div>
  );
});

export default Et3Margin;
